import ZendeskPopoverV2 from '../zendesk-popover-v2';

interface Props {
    onClose?: () => unknown;
    onSend?: () => unknown;
}

export default function ZendeskPopover({ ...props }: Props) {
    return <ZendeskPopoverV2 {...props} />;
}
